module.exports = __webpack_public_path__ + "img/akrav_no.f30a3979.png";